/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {distances, distanceUnits} from '../../constants/staticLists';
import AsyncTypeahead from 'react-bootstrap-typeahead/lib/AsyncTypeahead.react'; 
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as browserCheck from '../../utils/browserCheck.js';
import LocationService from '../../services/locationService';
import moment from 'moment';
import ErrorMessage from '../common/ErrorMessage.js';
import MaterialDropDown from '../common/MaterialDropDown';

class Browse extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.filter = this.filter.bind(this);
        this.onChange = this.onChange.bind(this);
        this.formIsValid = this.formIsValid.bind(this);
        this.loadSortOptions = this.loadSortOptions.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.updateGenre = this.updateGenre.bind(this);        
        this.filterClick = this.filterClick.bind(this);
        this.updateDistance = this.updateDistance.bind(this);
        this.updateDistanceUnit = this.updateDistanceUnit.bind(this);
        this.updateDates = this.updateDates.bind(this);
        this.getDateText = this.getDateText.bind(this);
        this.getGenreText = this.getGenreText.bind(this);
        this.locationSearch = this.locationSearch.bind(this);
        this.locationSelected = this.locationSelected.bind(this);  
        this.sortOptions = {};        
        const todayStart = moment().startOf('day');
        this.dates = [{
            name: 'All dates',
            startDate: todayStart,
            endDate: null
        }, {
            name: 'Today',
            startDate: todayStart,
            endDate: moment().endOf('day')
        }, {
            name: 'This week',
            startDate: moment(),
            endDate: moment().endOf('week').endOf('day')
        }, {
            name: 'This month',
            startDate: moment(),
            endDate: moment().endOf('month').endOf('day')
        }, {
            name: 'This year',
            startDate: moment(),
            endDate: moment().endOf('year').endOf('day')
        }];
    
        //we should initialise the location from the user's role if set
        this.state = {
            locationTypeaheadLoading: false,
            locationTypeaheadOptions: [],
            locationFocused: false,
            dateFocusedInput: null
        };
    }

    componentWillMount() {        
        this.loadSortOptions();            
        this.props.actions.updateSort('Date');        
        this.props.actions.updateDistanceUnit(distanceUnits[0]);    
        this.props.actions.updateDates(this.dates[0].startDate, this.dates[0].endDate);
        this.props.actions.browseGigs();
        if(!this.props.searchCriteria.location || !this.props.searchCriteria.location.length && this.props.user) {
            //default to the user's location
            const user = this.props.user;
            const label = user ? `${user.City}, ${user.Region}` : '';
            const items = [{
                  label: label,
                  value: label,
                  city: user ? user.City : '',
                  region: user ? user.Region : '',
                  country: user ? user.Country : '',
                  longitude: user ? user.Longitude : '',
                  latitude: user ? user.Latitude : ''
            }];
            this.props.actions.updateLocation(items);
        }
    }   

    componentDidMount() {
        if(browserCheck.canUseDom()) {                
            window.componentHandler.upgradeDom();      
            const {getmdlSelect} = require('../../scripts/getmdl-select.js');
            getmdlSelect.init('#divFilterResultsDrop .getmdl-select');     
            $('#DistanceUnit').parent().addClass('is-dirty');    
            $('#Dates').parent().addClass('is-dirty');    
            $('#Sort').parent().addClass('is-dirty');  
        }
    }    

    filterClick(event) {
        event.preventDefault();
        $(event.target).toggleClass('open');
        $('#divFilterResultsDrop').slideToggle();
    }

    loadSortOptions() {
        this.sortOptions['Date'] = 'Date';
        this.sortOptions['EventName'] = 'Event name';
    }

    updateSort(event, refreshData = false) {
        const value = event.target.dataset.val;
        this.props.actions.updateSort(value);
        if(refreshData) {
            this.filter(event);
        }
    }

    updateGenre(event) {
        //clicking seems to hide the drop down so let's add it back
        $('.multidropdown').addClass('open');
        const value = event.target.value;
        const checked = event.target.checked;
        if(checked) {
            this.props.actions.addBrowseGenre(value);
        }
        else {
            this.props.actions.removeBrowseGenre(value);
        }
    }

    updateDistance(event) {
        const value = event.target.innerText;
        this.props.actions.updateDistance(value);
    }

    updateDistanceUnit(event) {
        const value = event.target.innerText;
        this.props.actions.updateDistanceUnit(value);
    }

    updateDates(event, startDate, endDate) {
        this.props.actions.updateDates(startDate, endDate);
    }

    getDateText() {
        let date = this.dates.find(d => d.name === 'All dates');
        if(this.props.searchCriteria.startDate && this.props.searchCriteria.endDate) {
            const startDate = this.props.searchCriteria.startDate;
            const endDate = this.props.searchCriteria.endDate;
            date = this.dates.find(d => d.startDate === startDate && d.endDate === endDate);
        }
        return date ? date.name : '';
    }

    locationSearch(query) {
        this.setState({locationTypeaheadLoading: true});
        LocationService.searchLocation('', false, true, query)
        .then(items => {
            this.setState({
                locationTypeaheadLoading: false,
                locationTypeaheadOptions: items
            });
        } );
    }

    locationSelected(items) {
        this.props.actions.updateLocation(items);        
    }

    getGenreText() {
        if(this.props.searchCriteria.selectedGenres.length == 0) {
            return 'Select Genres';
        }
        else {
            const genreText = this.props.searchCriteria.selectedGenres.toString().replace(/,/g, ', ');
            return genreText;
        }
    }

    filter(event) {
        event.preventDefault();
        if(this.formIsValid()) {
            this.props.actions.browseGigs();
        }
    }

    onChange(event) {
        const field = event.target.name;
        const value = event.target.value;
        let newState = Object.assign({}, this.state);
		newState[field] = value;
		return this.setState(newState);
    }

    formIsValid() {
        return true;
    }

    render() {
        return (
            <React.Fragment>
                <div className="sfilt">
                    <form id="frmSort" name="form-sort" method="post" action="" className="form form-inline form-sort">
                        <div className="sortbox pull-right">
                            <label htmlFor="sortsel">Sort by:&nbsp;</label>
                            <MaterialDropDown 
                                name="Sort"
                                label=" "
                                data-val={this.props.searchCriteria.sort} 
                                value={this.sortOptions[this.props.searchCriteria.sort]}
                                onClick={(e) => this.updateSort(e, true)}
                                data={Object.keys(this.sortOptions)}
                                itemTextFunc={(key) => this.sortOptions[key]} />
                        </div>
                    </form>
                    <a id="aFilterResultsDrop" href="#" className="btn-sfilters btn-simple transition" style={{borderColor:'#ddd', marginTop:'20px', display:'inline-block'}} onClick={this.filterClick}>
                        Filter results&nbsp;
                        <span className="caret-dn">
                            <span className="arrow-down" />
                        </span>
                        <span className="caret-up">
                            <span className="arrow-up" />
                        </span>
                    </a>
                </div>
                <div style={{clear:'both'}} />
                <div id="divFilterResultsDrop" className="searchfilters">
                    <form id="frmSearchFilter" name="form-sfilter" method="post" action="" className="form form-regular form-block">
                        <ErrorMessage error={this.props.browseError} onClose={this.props.actions.clearBrowseError} />
                        <div className="row">
                            <div className="col-md-4">
                                <div id="divBrowseGenres" className="genre">
                                    <p className="formlegend">BY GENRE</p>
                                    <div className="dropdown multidropdown">
                                        <a href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                            <span className="selection">{this.getGenreText()}</span>
                                            <span className="caret" />
                                        </a>
                                        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                                            <ul className="list-unstyled">
                                                {
                                                    this.props.genres.map((genre, i) => 
                                                    {
                                                        const checked = this.props.searchCriteria.selectedGenres.includes(genre);
                                                        return <li key={genre}>
                                                            <label className="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" htmlFor={`checkbox-${i}`}>
                                                                {checked ?
                                                                    <input type="checkbox" id={`checkbox-${i}`} className="mdl-checkbox__input" name="SelectedGenres" value={genre} onChange={this.updateGenre} checked />
                                                                    : <input type="checkbox" id={`checkbox-${i}`} className="mdl-checkbox__input" name="SelectedGenres" value={genre} onChange={this.updateGenre} />}
                                                                <span className="mdl-checkbox__label">{genre}</span>
                                                            </label>
                                                        </li>;
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>                                
                            <div className="col-md-8">
                                <div className="row row-breakatsmall">
                                    <div className="col-xs-6">
                                        <p className="formlegend">WITHIN</p>
                                        <div className="form-within">
                                            <MaterialDropDown 
                                                name="Distance" 
                                                className="placeholder select-distance"
                                                data={distances}
                                                onClick={this.updateDistance}
                                                value={this.props.searchCriteria.distance} />
                                            <MaterialDropDown
                                                name="DistanceUnit"
                                                className="select-unit"
                                                value={this.props.searchCriteria.distanceUnit}
                                                data={distanceUnits}
                                                showLabel={false}
                                                onClick={this.updateDistanceUnit} />
                                        </div>
                                    </div>
                                    <div id="divLocation" className="col-xs-6">
                                        <p className="formlegend">OF</p>
                                        <div className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block ${this.state.locationFocused ? 'is-focused' : ''} ${this.props.searchCriteria.location && this.props.searchCriteria.location.length ? 'is-dirty' : ''}`}>
                                            <AsyncTypeahead id="Location"  minLength={3} isLoading={this.state.locationTypeaheadLoading} onSearch={this.locationSearch} onChange={this.locationSelected} options={this.state.locationTypeaheadOptions} selected={this.props.searchCriteria.location} onFocus={() => this.setState({locationFocused: true})} onBlur={() => this.setState({locationFocused: false})} />
                                            <label className="mdl-textfield__label" htmlFor="Location">City Name</label>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">  
                            <div id="dateRangeGigs" className="col-md-4 col-sm-6">
                                <p className="formlegend">BY DATE</p>
                                <MaterialDropDown
                                    name="Dates"
                                    value={this.getDateText()}
                                    className="select-date-range"
                                    data={this.dates}
                                    itemTextFunc={(date) => date.name}
                                    itemValueFunc={(date) => date.name}
                                    onClick={(e, date) => this.updateDates(e, date.startDate, date.endDate)} />    
                            </div>                                   
                            <div className="col-md-4 col-sm-12">
                                <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent btn-filter" style={{marginTop: '50px'}} onClick={this.filter}>FILTER</button>
                            </div>
                        </div>
                    </form>
                </div>
            </React.Fragment>
        );
    }
}

Browse.propTypes = {
    searchCriteria: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    browseError: PropTypes.string,
    genres: PropTypes.array.isRequired,
    user: PropTypes.object
};

export default Browse;


